const STATUS_CLASS_MAP = {
  draft: "draft",
  registration_open: "registration-open",
  registration_closed: "registration-closed",
  active: "active",
  completed: "completed",
  archived: "archived",
  scheduled: "scheduled",
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  ready: "ready",
  playing: "active",
  live: "active",
  disputed: "disputed",
  forfeited: "forfeited",
  upcoming: "upcoming",
};

function normalizeStatus(status) {
  return STATUS_CLASS_MAP[String(status || "").toLowerCase()] || "neutral";
}

function humanizeStatus(status) {
  return String(status || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function StatusBadge({ status, label, className = "" }) {
  const normalizedStatus = normalizeStatus(status);

  return (
    <span className={`appStatusBadge is-${normalizedStatus} ${className}`.trim()}>
      {label || humanizeStatus(status)}
    </span>
  );
}

export default StatusBadge;
